import React from "react";
import { useSelector } from "react-redux";
import Cart from "./Cart";

const Carts = () => {
    const { carts, products } = useSelector((state) => state);

    const totalItems = carts?.reduce(
        (prevCartQuantity, Cart) => prevCartQuantity + Cart.quantity,
        0
    );

    const totalPrice = carts.reduce((totalPrice, cart) => {
        const product = products.find(({ id }) => id === cart.id);
        return totalPrice + product.price * cart.quantity;
    }, 0);

    return (
        <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4">
            <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
                {carts.map(({ id, quantity }) => {
                    return <Cart key={id} id={id} quantity={quantity} />;
                })}
                <div className="flex justify-center items-center text-center">
                    <div className="text-xl font-semibold">
                        <p>Total Item</p>
                        <p className="text-5xl">{totalItems}</p>
                    </div>
                </div>
            </div>
            <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
                <div className="flex justify-center items-center text-center">
                    <div className="text-xl font-semibold">
                        <p>Total Price</p>
                        <p className="text-5xl">
                            {totalPrice.toLocaleString()}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carts;
